import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { parseDateMDY } from "utils/Utils";

const MandateDetails = ({ classes, mandateDetails }) => {
  const itemView = (label, value) => {
    return (
      <Grid item xs={12} sm={6} md={3} className={classes.fieldContainer}>
        <p style={{ marginBottom: 0 }}>
          <b>{label}</b>
        </p>
        <label>{value}</label>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} className={classes.inputFieldContainer}>
        <h2 className={classes.header} style={{ fontSize: "1.5rem" }}>
          Mandate Details
        </h2>
      </Grid>

      <Grid item xs={12} container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
          <Grid container className={classes.inputFieldContainer}>
            {itemView("Mandate Id", mandateDetails?.mandateId || "NA")}
            {itemView("Mandate State", mandateDetails?.mandateState || "NA")}
            {itemView("Max Amount", mandateDetails?.maxAmount || "NA")}
            {itemView("Customer Account Number",mandateDetails?.customerAccountNumber || "NA")}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

MandateDetails.propTypes = {
  classes: PropTypes.object,
  incomeDetails: PropTypes.object,
};

export default MandateDetails;
